import { AnyAction } from 'redux';
import { ApplicationState } from 'app/types-store';
import { ActionDispatching } from 'app/types-shared';
import { STATE } from 'app/constants';
import { ErrorNotification, SuccessNotification } from 'app/infrastructure/notifications/user-messages';
import { isForbiddenStatus, blockAccess } from 'app/area/shared/actions-utils';
import { experienceTransferTranslation } from '../constants';
import {
  ClearList, RequestOperationsList, ReceiveOperationsList, FailOperationsList,
  RequestUpdateOperations, ReceiveUpdateOperations, FailUpdateOperations
} from './action-types';
import { api } from './api';
import { mapOperationsList, mapUpdateOperations } from './map-list';
import { OperationsListItem, OperationsSearchModel } from './types-store';

export const actionCreators = {

  loadOperationsList: (
    model: OperationsSearchModel
  ): ActionDispatching<AnyAction, ApplicationState> =>
    async (dispatch, getState) => {

      const requestId = Date.now();
      dispatch(new RequestOperationsList(requestId, model));

      try {
        const listResponse = await api.loadOperationsList();
        dispatch(new ReceiveOperationsList(requestId, mapOperationsList(listResponse), listResponse.length));
      } catch (err) {
        err && err.userMessages && dispatch(new ErrorNotification(err.userMessages));

        if (isForbiddenStatus(err)) {
          blockAccess({
            dispatch,
            getState,
            area: STATE.experienceTransfer,
            translationId: experienceTransferTranslation.no_access_to_experience_transfer
          });
        }

        dispatch(new FailOperationsList(requestId));
      }
    },

  updateOperations: (id: number, listItems: OperationsListItem[], successMessage: string): ActionDispatching<any, any> =>
    async (dispatch: any, getState: () => ApplicationState) => {
      try {
        dispatch(new RequestUpdateOperations(listItems));
        await api.updateOperations(mapUpdateOperations(listItems));
        dispatch(new ReceiveUpdateOperations());
        dispatch(new SuccessNotification(successMessage));
      } catch (err) {
        err && err.userMessages && dispatch(new ErrorNotification(err.userMessages));
        dispatch(new FailUpdateOperations(id));
      }
    },

  clearList: (): ActionDispatching<AnyAction, ApplicationState> =>
    (dispatch, getState) => {
      const requestId = Date.now();
      dispatch(new ClearList(requestId));
    },

  displayError: (errorMessage: string): ActionDispatching<any, any> =>
    (dispatch, getState) => {
      dispatch(new ErrorNotification(errorMessage));
    }
};
